import { Option } from '@beeline/design-system-react/extracted-styles';

import { BookingInfo } from 'src/api/bookingsView';
import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';
import { ProgressState } from 'src/types';

export enum BookingsPageMode {
  Actual = 'actual',
  History = 'history',
}

export enum BookingsPageRole {
  Author = 'author',
  Responsible = 'responsible',
}

export interface BookingsState {
  loading: boolean;
  error?: string;
  from?: string | undefined;
  to?: string | undefined;
  bookingObjectType: BookingObjectType | undefined;
  mode?: BookingsPageMode | undefined;
  role?: BookingsPageRole | undefined;
  rows: BookingInfo[];
  now: Date | null;
  token: string | null;
  hasMore: boolean;
  currentRequestId: string | undefined;
  unbookings: Record<string, ProgressState>;
  employee: Option<string> | null;
  filtersAreOpened: boolean;
}
